var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"all_top"},[_c('img',{attrs:{"src":require("../assets/logo.jpg"),"alt":""},on:{"click":function($event){return _vm.$router.push({path:'/'})}}}),_vm._v(" "),_c('span',[_vm._v("欢迎登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a8fe5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assembly/login_top.vue
// module id = null
// module chunks = 